class pageCart extends HTMLElement {

	constructor() {

		super();

		this.disableCartSubmit();

		this.initListenQuantity();
	}

	// Disable cart submit

	disableCartSubmit() {
		// Wait for the DOM to be fully loaded
		document.addEventListener('DOMContentLoaded', function () {
			// Select the cart form by its new ID
			const cartForm = document.getElementById('cart-form');

			// Add an event listener for the form submission
			if (cartForm) {
				cartForm.addEventListener('submit', function (event) {
					// Check if the submitted button has the 'name="checkout"' attribute
					// or another unique identifier.
					const isCheckoutButton = event.submitter && event.submitter.name === 'checkout';

					// If the checkout button was clicked, let the form submit normally
					if (isCheckoutButton) {
						return; // Exit the function and let the default submit happen
					}
					// Prevent the default form submission (this is the key step)
					event.preventDefault();
				});
			}
		});
	}

	/**
	 * Listen when update the input quantity
	 * * @return {undefined}
	 */
	initListenQuantity() {
		document.querySelectorAll('[data-cart-page-item-id]').forEach(element => {
			element.addEventListener('change', event => {
				const productId = event.target.dataset.cartPageItemId;
				const cartLine = parseInt(event.target.dataset.cartLine, 10);
				const max = event.target.getAttribute('max');

				let quantity = parseInt(event.target.value, 10);
				if (Number.isNaN(quantity) || quantity < 0) {
					return;
				}
				if (max && quantity > parseInt(max, 10)) {
					quantity = parseInt(max, 10);
					event.target.value = quantity;

					// Update to target specific error message
					let message = null;
					if (productId) {
						message = document.querySelector('[data-cart-page-item-id="' + productId + '"]')
							.closest('.cart-page__product-quantity')
							.querySelector('[data-cart-item-error-message="' + productId + '"]');
					}
					// Fallback (though structure ensures it should be there)
					if (!message) {
						message = document.querySelector('[data-error-message]');
					}

					if (message) {
						message.textContent = "You can only add " + max + " of this item in cart.";
						// Clear message after 3 seconds
						setTimeout(() => {
							message.textContent = "";
						}, 5000);
					}
					// Continue to update cart with max value

					// Update button state
					if (window.theme && window.theme.quantity_selector && window.theme.quantity_selector.validateButton) {
						const container = event.target.closest('[data-quantity-selector]') || event.target.closest('.quantity-selector');
						if (container) {
							window.theme.quantity_selector.validateButton(event.target, container);
						}
					}
				}

				event.preventDefault();

				// 1. Get the elements to disable
				const cartForm = document.getElementById('cart-form');
				const quantityInputs = cartForm?.querySelectorAll('.quantity-selector__plus, .quantity-selector__minus');

				// 2. Disable all relevant elements
				quantityInputs?.forEach(input => input.disabled = true);

				// disable click event on the button and show disabled click cursor
				quantityInputs?.forEach(input => input.style.cursor = 'not-allowed');
				// reduce the opacity of the button
				quantityInputs?.forEach(input => input.style.opacity = '0.5');
				// change the background color of the button
				quantityInputs?.forEach(input => input.style.backgroundColor = '#f5f5f5');

				if (productId && cartLine > 0 && quantity >= 0) {
					fetch('/cart/change.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Accept': 'application/json'
						},
						body: JSON.stringify({
							line: cartLine,
							quantity: quantity
						})
					})
						.then(response => {
							if (!response.ok) {
								throw new Error(`HTTP error! status: ${response.status}`);
							}
							return response.json();
						})
						.then(cart => {
							this.reloadCartData(productId, quantity);
							// Select the cart count element
							const cartCountElement = document.getElementById('cart-item-count');

							// Check if the element exists and update its text content
							if (cartCountElement) {
								cartCountElement.textContent = cart.item_count;
							}

							// Pass cart data directly to avoid fetching it again
							this.reloadCartData(productId, quantity, cart);
						})
						.catch(error => {
							console.error('Error updating cart quantity:', error);
							// Optional: Reload cart data even on failure (this will fetch)
							this.reloadCartData(productId, quantity);
						})
						.finally(() => {
							// 3. Re-enable all relevant elements
							quantityInputs?.forEach(input => input.disabled = false);
							quantityInputs?.forEach(input => input.style.cursor = 'pointer');
							quantityInputs?.forEach(input => input.style.opacity = '1');
							quantityInputs?.forEach(input => input.style.backgroundColor = 'transparent');
						});
				}

				// Also validate button state after any change
				if (window.theme && window.theme.quantity_selector && window.theme.quantity_selector.validateButton) {
					const container = event.target.closest('[data-quantity-selector]') || event.target.closest('.quantity-selector');
					if (container) {
						window.theme.quantity_selector.validateButton(event.target, container);
					}
				}
			});
		});
	}


	updateCartItemVariant(oldLineItemKey, newVariantId, quantity) {
		// Remove the old line item completely
		fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				line: oldLineItemKey,
				quantity: 0
			})
		})
			.then(() => {
				// Add new variant with same quantity
				return fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						id: newVariantId,
						quantity: quantity
					})
				});
			})
			.then(() => {
				// Refresh cart data on page
				this.reloadCartData();
			})
			.catch(console.error);
	}

	updateVariantInCart(lineItemKey, newVariantId, currentQuantity) {
		try {
			// convert await to promise
			return new Promise((resolve, reject) => {
				// 1. Fetch current cart JSON
				const cart = fetch('/cart.js').then(res => res.json());
				// 2. Check if new variant exists already in the cart
				const existingItem = cart.items.find(item => item.variant_id === newVariantId);
				if (existingItem) {
					// 3a. If exists, update quantity of the existing item
					fetch('/cart/change.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							id: existingItem.key,
							quantity: existingItem.quantity + currentQuantity
						})
					})
						.then(() => {
							// 4a. Remove the original line item (set quantity to 0)
							fetch('/cart/change.js', {
								method: 'POST',
								headers: { 'Content-Type': 'application/json' },
								body: JSON.stringify({
									id: lineItemKey,
									quantity: 0
								})
							})
								.then(() => {
									// 5. Reload cart UI or page to reflect changes
									window.location.reload();
									resolve(true);
								})
								.catch(console.error);
						})
						.catch(console.error);
				} else {
					// 3b. If does not exist, add new variant with the current quantity
					fetch('/cart/add.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							id: newVariantId,
							quantity: currentQuantity
						})
					})
						.then(() => {
							// 4b. Remove the original line item
							fetch('/cart/change.js', {
								method: 'POST',
								headers: { 'Content-Type': 'application/json' },
								body: JSON.stringify({
									id: lineItemKey,
									quantity: 0
								})
							})
								.then(() => {
									// 5. Reload cart UI or page to reflect changes
									window.location.reload();
									resolve(true);
								})
								.catch(console.error);
						})
						.catch(console.error);
				}
			});

		} catch (error) {
			console.error('Error updating variant in cart:', error);
		}
	}



	/**
	 * Reload cart data (Prices)
	 * 
	 * @return {undefined}
	 */
	reloadCartData(id, qty_added, cartData) {

		if (cartData) {
			this.processCartData(cartData, id, qty_added);
		} else {
			fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
				return response.json();
			}).then(function (cart) {
				this.processCartData(cart, id, qty_added);
			}.bind(this)).catch(function (error) {
				console.log(error);
			});
		}
	}

	processCartData(cart, id, qty_added) {
		// Update Free Shipping Bar
		this.updateFreeShippingBar();

		// Set Cart Quantity
		window.theme.cart._setCartQuantity(cart.item_count);

		// Check AvailabilityStock
		this.checkAvailabilityStock(cart, id, qty_added)

		if (qty_added <= 0) {
			//remove product from cart
			window.location.href = '/cart';
		}
	}

	/**
	 * Update the progress bar (Free Shipping App)
	 * 
	 * @return {undefined}
	 */
	updateFreeShippingBar() {

		if (typeof window.updateFSPB != 'undefined') {
			window.updateFSPB();
		}
	}

	/**
	 * Check if product has unavailability stock
	 * 
	 * @return {undefined}
	 */
	checkAvailabilityStock(cart, id, qty_added) {
		// Attempt to find specific message container based on ID
		let message = null;
		if (id) {
			const input = document.querySelector('[data-cart-page-item-id="' + id + '"]');
			if (input) {
				message = input.closest('.cart-page__product-quantity')
					.querySelector('[data-cart-item-error-message="' + id + '"]');
			}
		}

		// Fallback or if not found (though logic above should handle it)
		if (!message) {
			// If we really can't find specific, maybe don't show global error for item specific stock issue if we can avoid confusion?
			// But let's fallback to global just in case to communicate something.
			message = document.querySelector('[data-error-message]');
		}

		if (!message) return null;

		cart.items.forEach(item => {
			if (id == item.id) {

				if (qty_added > item.quantity) {
					message.innerHTML = "";
					message.append("All " + item.quantity + " " + item.title + " are in your cart.");
					message.classList.add("active");
					// Auto hide after 3 seconds
					if (message.dataset.timeoutId) clearTimeout(parseInt(message.dataset.timeoutId));
					const tId = setTimeout(() => {
						message.innerHTML = "";
						message.classList.remove("active");
						delete message.dataset.timeoutId;
					}, 10000);
					message.dataset.timeoutId = tId;

					let input = document.querySelectorAll('[data-cart-page-item-id=\"' + item.id + '\"]');

					if (input) {
						input.forEach(element => {
							element.value = item.quantity;
							if (window.theme && window.theme.quantity_selector && window.theme.quantity_selector.validateButton) {
								const container = element.closest('[data-quantity-selector]') || element.closest('.quantity-selector');
								if (container) window.theme.quantity_selector.validateButton(element, container);
							}
						});
					}
				}
				else {
					message.innerHTML = "";
					message.classList.remove("active");
				}
			}
		});
	}
}

customElements.define('page-cart', pageCart);